import React, { Component } from 'react';
import {
  Bar,
  Label,
  XAxis,
  YAxis,
  Tooltip,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';
import moment from 'moment';
import { colors, chartColors } from '../../style/colors';
import { formatDollarValue } from '../../shared/chartUtility';

class CostBarChart extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.calculateOnUpdate) {
      return true;
    } else {
      if (nextProps.lastUpdateType === 'calculation') {
        return true;
      } else {
        return false;
      }
    }
  }

  getContractStartDay(date) {
    return moment(date).subtract(1, 'days').format('D');
  }

  getContractStartMonth(date) {
    return moment(date).subtract(1, 'days').format('MMMM');
  }

  getActiveYear(date) {
    return (
      Number.parseInt(moment(date).format('MMMM'), 10) +
      this.props.selectedYearIndex
    );
  }

  measureText = (text) => {
    this.ctx = document.createElement('canvas').getContext('2d');
    this.ctx.font = '12px "Roboto"';

    return this.ctx.measureText(text).width;
  };

  leftMargin = () => {
    let leftMargin = 0;
    for (const data of this.props.chartData) {
      const textWidth = this.measureText(data.year.toString().split(' ')[0]);

      if (textWidth > leftMargin) {
        leftMargin = textWidth;
      }
    }
    leftMargin = Math.max(0, leftMargin - 80);
    return leftMargin;
  };

  chartColors = () => {
    let newChartColors = [...chartColors];
    if (!this.props.chartData[0].Baseline) {
      newChartColors.unshift(chartColors[0]);
    }
    return newChartColors;
  };

  render() {
    const newChartColors = this.chartColors();
    const formatter = (value) => formatDollarValue(value);
    const leftMargin = this.leftMargin();

    const contractStartDay = this.getContractStartDay(
      this.props.contractStartDate,
    );
    const contractStartMonth = this.getContractStartMonth(
      this.props.contractStartDate,
    );
    let isAnimationActive = true;
    if (this.props.disableAnimation) {
      isAnimationActive = false;
    }
    let isToolTipsActive = true;
    if (this.props.disableToolTips) {
      isToolTipsActive = false;
    }
    let yMax = 0;
    this.props.chartData.forEach((dataPoint) => {
      this.props.proposalNames.forEach((proposalName) => {
        yMax = Math.max(yMax, dataPoint[proposalName]);
      });
    });
    yMax = yMax * 1.1;
    return (
      <React.Fragment>
        <ResponsiveContainer height='100%' width='99%'>
          <BarChart
            data={this.props.chartData}
            margin={{ top: 5, right: 30, left: leftMargin, bottom: 5 }}
            onMouseMove={(e) => this.props.showComparisons(e)}
          >
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis dataKey='year'>
              <Label
                value={`Year ending ${contractStartMonth} ${contractStartDay} of`}
                position='insideBottom'
                offset={-2}
              />
            </XAxis>
            <YAxis tickFormatter={formatter} domain={[0, yMax]} />
            {isToolTipsActive && (
              <Tooltip formatter={formatter} isAnimationActive={false} />
            )}
            <Bar
              dataKey='Baseline'
              fill={newChartColors[0]}
              isAnimationActive={isAnimationActive}
            />
            {this.props.proposalIsChanged && (
              <Bar
                dataKey={this.props.currentProposalImpactName}
                fill={colors.lightblue}
                isAnimationActive={isAnimationActive}
              />
            )}
            <Bar
              dataKey={this.props.currentProposalName}
              fill={newChartColors[1]}
              isAnimationActive={isAnimationActive}
            />

            {this.props.comparedProposalsNames.map((name, i) => {
              return (
                <Bar
                  type='linear'
                  key={name}
                  dataKey={name}
                  fill={newChartColors[i + 2]}
                  isAnimationActiuve={isAnimationActive}
                />
              );
            })}
          </BarChart>
        </ResponsiveContainer>
      </React.Fragment>
    );
  }
}

export default CostBarChart;
